import React from 'react';
import { Linkedin, Twitter, Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info with Office Building Image */}
          <div>
            <img 
              src="/logo.jpg" 
              alt="Adidar Technologies" 
              className="h-32 md:h-36 w-auto object-contain mb-4 brightness-0 invert"
            />
            
            {/* Office Building Image */}
            <div className="mb-4 rounded-lg overflow-hidden">
              <img
                src="/office-building.png"
                alt="Adidar Tech Office Building"
                className="w-full h-auto object-cover"
              />
            </div>
            
            <p className="text-sm text-gray-400 leading-relaxed">
              Leading IT solutions provider delivering cutting-edge technology services across industries.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-sm hover:text-cyan-400 transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm hover:text-cyan-400 transition-colors">
                  Services
                </a>
              </li>
              <li>
                <a href="#industries" className="text-sm hover:text-cyan-400 transition-colors">
                  Industries
                </a>
              </li>
              <li>
                <a href="#technologies" className="text-sm hover:text-cyan-400 transition-colors">
                  Technologies
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm hover:text-cyan-400 transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Our Services */}
          <div>
            <h3 className="text-white font-bold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-sm hover:text-cyan-400 transition-colors">
                  AI & Machine Learning
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm hover:text-cyan-400 transition-colors">
                  Cloud Solutions
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm hover:text-cyan-400 transition-colors">
                  Custom Software
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm hover:text-cyan-400 transition-colors">
                  Data Analytics
                </a>
              </li>
              <li>
                <a href="#services" className="text-sm hover:text-cyan-400 transition-colors">
                  Cybersecurity
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Us */}
          <div>
            <h3 className="text-white font-bold mb-4">Contact Us</h3>
            <div className="space-y-4">
              <div>
                <h4 className="text-cyan-400 font-semibold mb-2 text-sm">Chennai Office</h4>
                <div className="space-y-1 text-sm">
                  <div className="flex items-start gap-2">
                    <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                    <p className="text-xs">P.No.2B, KAKKANJI STREET, THARAPPAKKAM, PALLAVARAM TK, Thandalem, Kanchipuram, Sriperumbudur, Tamil Nadu, India, 600128</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <Phone className="w-4 h-4" />
                    <span className="text-xs">+91-9944562638</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Phone className="w-4 h-4" />
                    <span className="text-xs">08772 220889</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Mail className="w-4 h-4" />
                    <span className="text-xs">contact@adidartechindia.tech</span>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="text-cyan-400 font-semibold mb-2 text-sm">Bangalore Office</h4>
                <div className="space-y-1 text-sm">
                  <div className="flex items-start gap-2">
                    <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                    <p className="text-xs">Novel Office, Electronic City Phase 1, Bangalore, Karnataka - 560100</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <Phone className="w-4 h-4" />
                    <span className="text-xs">+91-9944562638</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Phone className="w-4 h-4" />
                    <span className="text-xs">08772 220889</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Mail className="w-4 h-4" />
                    <span className="text-xs">contact@adidartechindia.tech</span>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="text-cyan-400 font-semibold mb-2 text-sm">Tirupati Office</h4>
                <div className="space-y-1 text-sm">
                  <div className="flex items-start gap-2">
                    <MapPin className="w-4 h-4 flex-shrink-0 mt-0.5" />
                    <p className="text-xs">Ground Floor, 22-8-257/M, 12th cross, Upadyada Nagar, Tirupati, Andhra Pradesh 517501</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <Phone className="w-4 h-4" />
                    <span className="text-xs">+91-9944562638</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Phone className="w-4 h-4" />
                    <span className="text-xs">08772 220889</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Mail className="w-4 h-4" />
                    <span className="text-xs">contact@adidartechindia.tech</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © 2014 Adidar Tech India Private Limited. All rights reserved.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.linkedin.com/in/adidar-technologies-67bb63361/" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;